import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as api from './startPageAPI';

const initialState = {
  status: 'idle',
  statisticsData: []
};

export const fetchUserDocumentStatistics = createAsyncThunk(
  'startPage/fetchUserDocumentStatistics',
  async () => {
    const response = await api.fetchUserDocumentStatistics();
    return response.body;
  }
);

export const startPageSlice = createSlice({
  name: 'startPage',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDocumentStatistics.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserDocumentStatistics.fulfilled, (state, action) => {
        state.statisticsData = action.payload;
        state.status = 'idle';
      })
      .addCase(fetchUserDocumentStatistics.rejected, (state) => {
        state.status = 'error';
      });
  }
});

export const selectStatisticsData = (state) => state.startPage.statisticsData;
export const selectStatus = (state) => state.startPage.status;

export default startPageSlice.reducer;
